<template>
  <div class="container">

    <div class="tabbar">
      <div class="sub flex-center">
        <img src="@/static/images/arrow-left-white.png"
        @click="back" />
        <div class="title flex-center">
          <span>批量充值</span>
        </div>
      </div>
    </div>

    <div class="inputWrap">
      <div class="textLeft title">批量充值:</div>
      <div class="tip_batch">1.输入手机号一行一个，或用逗号分隔，单次提交不超过200个号码</div>
      <div class="tip_batch">2.若批量充值有号码失败，将自动退回钱包，请留意钱包余额。</div>
      <el-input class="inputArea" @input="theInput" type="textarea" rows="6" placeholder="在此输入手机号"
        v-model="inputNumber" maxlength="" show-word-limit>
      </el-input>

    </div>
    <div class="mobile-list flex-column">
      <div class="title">确认号码列表</div>
      <div class="phoneList">
        <div class="phoneItem flex "  :class="[item.theType=='error'||item.type!=type?'error':'']" v-for="(item,index) in brr">
          <div class="sign">{{index+1}}、</div>
          <div class="phone">{{item.number}}</div>
          <div class="operator ">
            {{item.theType}}
            <!-- <i @click="delNumber(index)" class="el-icon-circle-close"></i> -->
            <div class="item-close flex-center" @click="delNumber(index)">
              <i class="el-icon-close"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="btnArea flex-center">
      <el-button class="historycard" @click="submit" type="success">确认提交</el-button>
    </div>

    <!-- <navBar :idx="0"></navBar> -->
  </div>
</template>

<script>
  import navBar from '@/components/navBar';
  import {getUrlParam} from '@/util/util';
  import config from '@/config';
  export default {
    name: 'multiRecharge',
    components: {
      navBar
    },
    data() {
      return {
        inputNumber: '',
        arr: [],
        brr: [],
        numbers: [],
        photo: "",
        type: null,
      }
    },
    created() {
      this.getLogin();
    },
    methods: {
      back() {
        this.$router.go(-1)
      },
      getLogin(){
        let auth_token = localStorage.getItem('auth_token');
        if (!auth_token) {
          let code = this.$route.query.code || getUrlParam('code');
          switch(this.$client) {
           case 'wxh5':
              if (code) {
                this.$api
                  .request('Wx/grantLogin', { code: code, settlement: 1 })
                  .then(({ data }) => {
                    this.$message({
                      message: "登录成功！",
                      type: "success"
                    })
                  })
                  .catch(error => {
                    this.$message({
                      message: "登录失败！",
                      type: "warning"
                    })
                    this.$router.push('/multiRecharge');
                  });
              } else {
                window.location.href = config.api_url+'Wx/grant';
              }
              break;
           case 'magapp':
              if (code) {
                this.$api
                  .request('System/grantLogin', { code: code })
                  .then(({ data }) => {
                    this.$message({
                      message: "登录成功！",
                      type: "success"
                    })
                  })
                  .catch(error => {
                    this.$message({
                      message: "登录失败！",
                      type: "warning"
                    })
                     this.$router.push('/multiRecharge');
                  });
              } else {
                window.location.href = config.login_url;
              }
              break;
            case 'h5':
              this.$confirm(' ', '请选择', {
                distinguishCancelAndClose: true,
                confirmButtonText: '登录充值',
                cancelButtonText: '游客充值'
              }).then((action) => {
                this.$router.push('/login');
              }).catch(() => {});
              break;
           default:
              this.$message({
                 message: "非法客户端！",
                 type: "warning"
              })
              break;
          }
        }
      },
      submit() {
        let typeUnique = true;
        this.numbers = [];
        this.brr.forEach((row) => {
          if (row.type != this.type) {
            typeUnique = false;
            return false;
          }
          if (row.theType != 'error') {
            this.numbers.push(row.number);
          }
          return true;
        })

        if (!typeUnique) {
          this.$message({
            message: "请统一运营商",
            type: "warning"
          })
          return false;
        }

        if (!this.numbers || this.numbers.length == 0) {
          this.$message({
            message: "请输入号码后,再点击充值",
            type: "warning"
          })
          return false;
        }

        if (this.numbers.length > 200) {
          this.$message({
            message: "最多添加200个号码",
            type: "warning"
          })
          return false;
        }
        this.$router.push({
          name: 'choice',
          params: {
            numbers: this.numbers,
            type:this.type
          }
        })
      },
      delNumber(n) {
        console.log(n);
        if (n < 0) {
          return this.brr;
        } else {
          this.brr = this.brr.slice(0, n).concat(this.brr.slice(n + 1, this.brr.length));
          this.type=this.brr[0].type;
          this.numbers = [];
          this.brr.forEach((row) => {
            if (row.theType != 'error') {
              this.numbers.push(row.number);
            }
          })
          this.inputNumber = this.numbers.length > 0 ? this.numbers.join(',') : '';
          this.theInput(this.inputNumber);
        }
      },
      theInput(e) {
        if (e == '' || !this.numbers) {
          this.brr = [];
          this.type = null;
          return;
        }
        this.arr = this.inputNumber.split(/,|，|\s+/)
        this.brr = this.arr.map((item, index, arr) => {
          let num = item.replace(/^\.+|[^\d.]/g, '');
          let check = this.common.test(num);
          var item = {
            theType: "",
            number: "",
            type:""
          };

          // 判断是否为充值号码
          if (check) {
            switch (check) {
              case 1:
                item.theType = "GLOBE/TM";
                item.type=1;

                break;
              case 2:
                item.theType = "SMART/TNT";
                 item.type=2;

                break;
              case 3:
                item.theType = "SUN";
                 item.type=3;

                break;
              case 4:
                item.theType = "DITO";
                 item.type=4;
                break;
            }
          } else {
            item.theType = "error"
            item.type=0
          }

          if (num.length == 0 || num.length < 10) {
            item.theType = "error"
            item.type=0
            num = "错误的号码"
          } else if (num.length >= 10) {
            num = num.substring(0, 10)
            num = parseInt(num)
            if (!this.type) {
              this.type = item.type;
            }
          }

          item.number = num
          return item
        })
      }
    }
  }
</script>

<style scoped>
  .item-close {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 14px;
    height: 14px;
    background: #c4c4c4;
    border-radius: 50%;
  }

  .item-close .el-icon-close {
    font-size: 9px;
    color: #f8f8fa;
  }

  .mobile-list {
    margin-top: 11px;
  }

  .mobile-list .title {
    color: #686777;
    font-family: Poppins;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    text-align: left;
  }

  .tabbar {
    width: 100%;
    height: 130px;
    background: url('../static/images/round.png') no-repeat;
    background-size: 100% auto;
    background-position: bottom;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    max-width: 750px;
    margin: auto;
  }

  .tabbar .sub {
    /* margin-top: 67px; */
    margin-top: 60px;
    text-align: center;
    position: relative;
  }

  .tabbar .sub img {
    position: absolute;
    width: 24px;
    height: auto;
    left: 32px;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .tabbar .sub .title {
    height: 24px;
  }

  .tabbar .sub span {
    color: #fff;
    font-family: 思源黑体 CN;
    font-size: 18px;
    font-weight: 900;
    line-height: 18px;
    letter-spacing: 0.7px;
    margin-top: -2.7px;
  }

  .inputWrap .title {
    background: linear-gradient(180.00deg, rgb(237, 58, 66),rgb(163, 24, 31));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    font-family: Poppins;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    margin-bottom: 4px;
  }

  .tip_batch {
    text-align: left;
    font-family: Poppins;
    font-size: 11px;
    font-weight: 400;
    line-height: 17px;
    background: linear-gradient(180.00deg, rgb(237, 58, 66),rgb(163, 24, 31));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }
  .container {
    /* margin: 30px 13px; */
    margin: 139px 10.5px 0 10.5px;
  }

  .textLeft {
    text-align: left;
  }

  /* .title {
    margin-bottom: 10px;
  } */

  .inputArea {
    width: 100%;
    margin-top: 9px;
  }

  /deep/ .inputArea .el-textarea__inner {
    border: 0.5px solid rgb(104, 103, 119) !important;
    border-radius: 5px;
    height: auto;
    /* Background / White */
    background: rgb(255, 255, 255);
    min-height: 155px !important;
    overflow: hidden;
  }

  /deep/ .inputArea .el-textarea__inner::-webkit-input-placeholder {
    color: #686777;
  }

  .inputArea textarea {
    min-height: 155px;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 500;
  }

  .el-textarea__inner {
    min-height: 155px;
  }

  .phoneList {
    padding: 6px 0;
    margin-bottom: 100px;
    box-sizing: border-box;
  }

  .phoneItem {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    /* margin-bottom: 10px; */
    margin-bottom: 4px;
    /* padding: 5px;
    background-color: #F5F5F5; */
    height: 27px;
    box-sizing: border-box;
    border: 0.5px solid rgb(238, 238, 238);
    border-radius: 5px;
    background: rgb(248, 248, 250);
    padding: 0 6px;
    color: #686777;
    font-family: Poppins;
    font-size: 13px;
    font-weight: 300;
    line-height: 20px;
  }

  .phoneItem.error {
    background-color: #e43;
    color: #fff;
  }

  .phoneItem:nth-child(even) {}

  .phoneItem:nth-child(odd) {}

  .phoneItem .sign {
    width: 40px;
  }

  .phoneItem .phone {
    width: calc(60% - 24px);
    text-align: left;
  }

  .phoneItem .operator {
    width: 40%;
    text-align: left;
    box-sizing: border-box;

    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    white-space: nowrap;
    padding-right: 15px;
  }

  .inputArea .el-textarea__inner {
    min-height: 200px !important
  }

  .el-icon-circle-close {
    /* margin-left: 5px; */
    /* float: right; */
    position: absolute;
    right: 0;

  }

  .btnArea {
    /* margin-bottom: 100px; */
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 75px;
    padding: 10.5px;
    max-width: 750px;
    margin: auto;
  }

  @media screen and (min-width: 750px) {
    .tabbar .sub {
      /* margin-top: 67px; */
      margin-top: 35px;
    }
  }

  .btnArea .historycard {
    width: 100%;
    /* width: 50%; */
    height: 61px;
    border-radius: 10px;
    box-shadow: inset 0 -0.5px 0 0 rgb(226, 227, 228);
    background: linear-gradient(180.00deg, rgb(255, 202, 0),rgb(255, 107, 0) 100%);
    border: none;
  }
  /deep/ .btnArea .historycard span {
    font-family: 思源黑体;
    font-size: 24px;
    font-weight: 700;
    line-height: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/page/multiRecharge.vue